import { render, staticRenderFns } from "./UiNotFoundBlock.vue?vue&type=template&id=4ef01f9b&scoped=true&"
import script from "./UiNotFoundBlock.vue?vue&type=script&lang=js&"
export * from "./UiNotFoundBlock.vue?vue&type=script&lang=js&"
import style0 from "./UiNotFoundBlock.vue?vue&type=style&index=0&id=4ef01f9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef01f9b",
  null
  
)

export default component.exports